// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"74":"About","229":"my-app-helloworld","276":"myapp-parent","784":"Logins"}[chunkId] || chunkId) + "-legacy." + {"74":"2043b475","229":"eb26f349","276":"d286990f","784":"2bf91361","874":"b511bd10"}[chunkId] + ".js";
};